import * as React from 'react';
import {Button, PaddingModes} from '@wix/wix-ui-tpa/cssVars';
import {ChevronRight} from '../../../../../icons/dist';
import s from './Arrow.scss';
import {classes as arrowStylable} from './Arrow.st.css';
import classNames from 'classnames';
import {withGlobals} from '../../../../../globalPropsContext';
import {IGalleryGlobalProps} from '../../../../../gallery/galleryGlobalStrategy';

export enum ArrowDirection {
  RIGHT = 'right',
  LEFT = 'left',
}

export interface ArrowProps extends IGalleryGlobalProps {
  onClick(): void;
  onKeyPress(): void;
  direction: ArrowDirection;
  ariaLabel: string;
  className?: string;
  dataHook: string;
}

const ArrowWithoutGlobals: React.FC<ArrowProps> = ({
  onClick,
  onKeyPress,
  direction,
  ariaLabel,
  className,
  dataHook,
}) => {
  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
    onClick();
  };

  const handleKeyPress = (event: React.KeyboardEvent) => {
    event.stopPropagation();
    event.preventDefault();
    onKeyPress();
  };

  return (
    <Button
      data-hook={dataHook}
      type={'button'}
      aria-label={ariaLabel}
      paddingMode={PaddingModes.explicitPaddings}
      onClickCapture={handleClick}
      onKeyPressCapture={handleKeyPress}
      className={classNames(s.arrow, s[direction], arrowStylable.arrowButton, className)}>
      <ChevronRight className={s.chevron} />
    </Button>
  );
};

export const Arrow = withGlobals(ArrowWithoutGlobals);
